import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { CoachComponent } from './coach.component';
import { CoachListComponent } from './coach-list/coach-list.component';
import { CoachDetailComponent } from './coach-detail/coach-detail.component';

const routes: Routes = [
  {
    path: '',
    component: CoachComponent,
    children: [
      {
        path: '',
        component: CoachListComponent
      },
      {
        path: 'detail/:id',
        component: CoachDetailComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoachRoutingModule {
}
